import { Component, OnInit } from '@angular/core';
import { ToasterService } from '../../services/global/toast-service'

@Component({
  selector: 'toast-message',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent implements OnInit {
  notifications: { type: string, message: string, id: number }[] = [];

  constructor(private toasterService: ToasterService) { }

  ngOnInit(): void {
    this.toasterService.getNotifications().subscribe(notification => {
      this.notifications.push(notification);
      setTimeout(() => {
        this.dismissNotification(notification.id);
      }, 3000); // Automatically dismiss after 3 seconds
    });
  }

  dismissNotification(id: number): void {
    this.notifications = this.notifications.filter(n => n.id !== id);
  }
}
